import { Card } from "@/src/components/cards";
import {
  FetchableList
} from "@/src/components/fetchableLists";
import {
  AppointmentStatus,
  appointmentStatuses,
  PatientItemStatus,
  patientItemStatuses,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { fromNow, getUserShortName } from "@/src/utils/utils";
import { useState } from "react";

export function StatusesHistory({
  itemId,
}: {
  itemId: string | null | undefined;
}) {
  const [reload, setReload] = useState(0);

  return (
    <FetchableList
      queryKey={[`StatusesHistory`, itemId, reload]}
      queryFn={() => apiFetch("general", "loadStatusChanges", { itemId })}
    >
      {(data) => {
        data?.map((statusChange) => {
          let newStatus = statusChange.newStatus;
          let status: any = appointmentStatuses[newStatus as AppointmentStatus];
          if (!status)
            status = patientItemStatuses[newStatus as PatientItemStatus];
          return (
            <Card
              key={statusChange.id}
              color="blue"
              title={status.name || statusChange.newStatus}
              subTitle={getUserShortName(statusChange.creator)}
            >
              <div className="gray">{fromNow(statusChange._date)}</div>
            </Card>
          );
        });
      }}
    </FetchableList>
  );
}
